import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import type { GetTasksArgs, GetTaskSubmitRecordsArgs } from './tasks.types';

import {
  getTaskDetailRequest,
  getTasksRequest,
  getTaskSubmitRecordDetailRequest,
  getTaskSubmitRecordsRequest,
} from './tasks.request';

export const tasksInfiniteQueryOptions = ({
  ...args
}: Omit<GetTasksArgs, 'cursor'>) =>
  infiniteQueryOptions({
    queryFn: ({ pageParam }) => getTasksRequest({ cursor: pageParam, ...args }),
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    getPreviousPageParam: (firstPage) => firstPage.prev_cursor,
    initialPageParam: '',
    queryKey: ['tasks', { ...args }],
  });

export const taskDetailQueryOptions = (taskId: string) =>
  queryOptions({
    queryFn: () => getTaskDetailRequest(taskId),
    persister: undefined,
    queryKey: ['task-detail', { taskId }],
  });

export const taskSubmitRecordInfiniteQueryOptions = ({
  courseTaskUuid,
  courseUuid,
}: GetTaskSubmitRecordsArgs) =>
  infiniteQueryOptions({
    queryFn: ({ pageParam }) =>
      getTaskSubmitRecordsRequest({
        courseTaskUuid,
        courseUuid,
        cursor: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    getPreviousPageParam: (firstPage) => firstPage.prev_cursor,
    initialPageParam: '',
    queryKey: ['task-submit-record', { courseTaskUuid, courseUuid }],
  });

export const taskSubmitRecordDetailQueryOptions = (taskResultUuid: string) =>
  queryOptions({
    queryFn: () => getTaskSubmitRecordDetailRequest(taskResultUuid),
    queryKey: ['task-submit-record-detail', { taskResultUuid }],
  });
